import { IStore } from 'store/configureStore';
import { selectDetailState } from '../../AssignmentInfo/store/selectors';

export function selectShowAssignmentStartDateChangeDialog(state: IStore): boolean {
    return selectDetailState(state)?.showAssignmentStartDateChangeDialog || false;
}
